import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/Exam-image-close.svg'
import _imports_1 from '@/assets/icons/replace-image.svg'


const _hoisted_1 = { class: "flex gap-4 border-none p-0 w-full overflow-hidden" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "flex flex-col items-center" }
const _hoisted_4 = {
  for: "file-input",
  class: "bg-transparent font-bold cursor-pointer text-[rgba(121,128,244,1)] rounded-xl underline"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "relative w-full overflow-hidden"
}
const _hoisted_7 = ["dir"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLocalized)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          disabled: !_ctx.canSelectMore,
          class: _normalizeClass(["border-2 border-dashed border-gray-300 rounded-xl p-5 text-center cursor-pointer transition-colors duration-300 min-w-[11rem] w-[11rem] h-[8.25rem] flex justify-center items-center flex-shrink-0 mt-[1rem]", {
        'bg-gray-100': _ctx.isDragging,
        'opacity-50 cursor-not-allowed': !_ctx.canSelectMore
      }]),
          onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          onDrop: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
          onDragenter: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.isDragging = true), ["prevent"])),
          onDragleave: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createStaticVNode("<i class=\"mb-2\" data-v-b1414798><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-b1414798><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\" data-v-b1414798></path><polyline points=\"17 8 12 3 7 8\" data-v-b1414798></polyline><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\" data-v-b1414798></line></svg></i>", 1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("common.drag_and_drop")), 1),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("common.or")) + " ", 1),
              _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("common.browse")), 1)
            ]),
            _createElementVNode("input", {
              disabled: !_ctx.canSelectMore,
              id: "file-input",
              type: "file",
              multiple: "",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelection && _ctx.handleFileSelection(...args))),
              accept: "image/*",
              class: "hidden"
            }, null, 40, _hoisted_5)
          ])
        ], 42, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.allFiles.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.canShowArrow)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.scrollNext && _ctx.scrollNext(...args))),
                class: _normalizeClass([
          'absolute top-1/2 -translate-y-1/2 z-10 bg-[rgba(121,128,244,1)] hover:bg-[rgba(100,108,255,1)] rounded-full p-2 text-white shadow-md transition-transform',
          _ctx.isRTL ? 'end-0 rotate-180' : 'end-0'
        ])
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "w-5 h-5 text-white",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 5l7 7-7 7"
                  })
                ], -1)
              ]), 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            ref: "scrollContainer",
            dir: _ctx.isRTL ? 'rtl' : 'ltr',
            class: _normalizeClass([
          'flex gap-4 scroll-smooth px-2 pt-[1rem] scrollbar-none overflow-x-auto',
          _ctx.isRTL
            ? _ctx.canScroll
              ? 'flex-row-reverse w-full'
              : 'flex-row-reverse w-fit'
            : 'flex-row w-full max-w-full'
        ]),
            onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.checkScroll && _ctx.checkScroll(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFiles, (file, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "relative flex-shrink-0"
              }, [
                _createElementVNode("img", {
                  src: file.preview,
                  alt: "image",
                  class: "h-[8.25rem] w-[11rem] object-cover rounded-xl border border-gray-300"
                }, null, 8, _hoisted_8),
                (!_ctx.isLocalized)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.removeFile(index)),
                      class: "absolute -top-3 -right-3 w-[2rem] h-[2rem] flex items-center justify-center"
                    }, _cache[9] || (_cache[9] = [
                      _createElementVNode("img", {
                        class: "w-[2rem] h-[2rem]",
                        src: _imports_0,
                        alt: "x icon"
                      }, null, -1)
                    ]), 8, _hoisted_9))
                  : _createCommentVNode("", true),
                (_ctx.isLocalized)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.replaceFile(index)),
                      class: "absolute bottom-[0.5rem] right-[0.5rem] w-[2.5rem] h-[2.5rem]"
                    }, _cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "flex justify-center items-center w-[2.5rem] h-[2.5rem] rounded-full bg-[rgba(0,0,0,0.7)]" }, [
                        _createElementVNode("img", {
                          class: "w-[1.375rem] h-[1.375rem]",
                          src: _imports_1,
                          alt: "replace icon"
                        })
                      ], -1)
                    ]), 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 42, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}